var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyprojectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9326 -0.166992L11.1475 -0.155273C11.6451 -0.104285 12.1129 0.117663 12.4678 0.476562L17.0352 5.11719L17.1787 5.27637C17.4939 5.66401 17.6677 6.15046 17.667 6.6543V18.0605L17.6572 18.2744C17.5574 19.3281 16.6748 20.1569 15.5938 20.167H4.40625C3.25299 20.1562 2.32522 19.2138 2.33301 18.0605V1.93848C2.32574 0.785628 3.25331 -0.156219 4.40625 -0.166992H10.9326ZM3.5 18.0654C3.49443 18.5743 3.90124 18.992 4.41016 19H15.5898C16.0995 18.992 16.5065 18.573 16.5 18.0635V6.6543C16.5005 6.41918 16.42 6.19173 16.2734 6.01074L16.2061 5.93555L11.6377 1.2959L11.5645 1.22852C11.4125 1.10276 11.2265 1.02486 11.0303 1.00488L10.9316 1H4.41016L4.31543 1.00586C3.85109 1.06054 3.49382 1.45907 3.5 1.93652V18.0654Z",
    fill: "#3F3F3F",
    stroke: "#3F3F3F",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.5833H6.66672C5.74631 14.5833 5 13.8371 5 12.9167C5 11.9962 5.74631 11.25 6.66672 11.25H13.3334C14.2538 11.25 15 11.9962 15 12.9167C15 13.8371 14.2538 14.5833 13.3334 14.5833ZM6.66672 12.0833C6.20651 12.0833 5.83344 12.4564 5.83344 12.9167C5.83344 13.3769 6.20651 13.75 6.66672 13.75H13.3334C13.7936 13.75 14.1667 13.3769 14.1667 12.9167C14.1667 12.4564 13.7936 12.0833 13.3334 12.0833H6.66672Z",
    fill: "#3F3F3F",
    stroke: "#3F3F3F",
    strokeWidth: 0.222222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 6.25H12.0207C11.1355 6.24878 10.4181 5.53146 10.417 4.6463V2.5H11.2503V4.6463C11.251 5.07141 11.5956 5.41595 12.0207 5.41672H14.5837V6.25Z",
    fill: "#3F3F3F",
    stroke: "#3F3F3F",
    strokeWidth: 0.222222
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyprojectIcon);
export default __webpack_public_path__ + "static/media/myprojectIcon.7e49eb920c395b9b306066533104f1b6.svg";
export { ForwardRef as ReactComponent };